<div id="home" class="scrollTarget">
	<div class="section">
		<particles></particles>
		<section id="main" class="main">
			<div class="keyArtContainer">
				<div class="keyart"></div>
			</div>
			<div class="buttonWrapper">
				<h3 i18n="claim1@@keyart.claim1">Unite your Realm</h3>
				<h2 i18n="claim2@@keyart.claim2">Ascend to victory</h2>
				<register-button *ngIf="!env.settings.preRegOnly" angulartics2On="click" angularticsAction="reg_openPopup_keyart" angularticsCategory="registration"></register-button>
				<preregister-button *ngIf="env.settings.preRegOnly" angulartics2On="click" angularticsAction="prereg_openPopup_keyart" angularticsCategory="preregistration"></preregister-button>
				<div class="more">
					<a href="#races" class="nav-link js-scroll-trigger" id="to-bottom" angularticsAction="toRaces" angularticsCategory="navigation"></a>
				</div>
			</div>
		</section>
	</div>
</div>